import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  list: [],
  listCount: 0,
  loading: false,
};
const notificationSlice = createSlice({
  name: "notificationList",
  initialState,
  reducers: {
    setNotifications: (state, action) => {
      state.list = action.payload;
    },
    setNotificationCount: (state, action) => {
      state.listCount = action.payload;
    },
    setNotificationLoader: (state, action) => {
      state.loading = action.payload;
    },
    resetNotifications: () => initialState,
  },
});

export const {
  setNotifications,
  setNotificationCount,
  setNotificationLoader,
  resetNotifications,
} = notificationSlice.actions;

export default notificationSlice.reducer;
